export class AgentGroup {
    constructor(
        public name = "Default",
        public displayName = "Development",
        public environment = "Default",
        public environmentDisplayName = "Development",
        public allowLogEverything?: boolean,
        public allowRunningTestProcesses?: boolean,
        public isCrossPlatform?: boolean,
        public agents: AgentConfiguration[] = []) { }
}

export interface AgentVersionInfo {
    name: string;
    agentGroupName: string;
    version: string;
    isOffline: boolean;
}

export interface AgentGroupData {
    name: string;
    displayName: string;
    environmentName: string;
    environmentDisplayName: string;
    allowRunningTestProcesses: boolean;
    agents: AgentConfiguration[];
    isCrossPlatform: boolean;
    allowLogEverything: boolean;
}

export interface AgentConfiguration {
    name: string;
    httpPorts: string[];
    httpsPorts: string[];
    url: string;
    expandedUrls: string[];
}

export const defaultAgentGroupName = "Default";
export const defaultEnvironmentName = "Default";
